import React from 'react';
import { useTheme } from 'styled-components';
import { Theme } from '@amzn/storm-ui';
import { SvgIconWrapper } from './styles';
import { orange } from 'src/colors';
import { useIsRTL } from 'src/commons/hooks';

interface SvgIconProps {
  isSelected?: boolean;
  iconPath: string;
  ariaLabel: string;
}

export const SvgIcon: React.FC<SvgIconProps> = ({
  isSelected,
  iconPath,
  ariaLabel,
}) => {
  const theme = useTheme() as Theme;
  const isRtl = useIsRTL();
  const fill = !isSelected ? theme.icon.color.default : orange;

  return (
    <SvgIconWrapper
      src={iconPath}
      fillColor={fill}
      isRtl={isRtl}
      key={fill}
      aria-label={ariaLabel}
      preProcessor={(code) => {
        code = code.replace(/filter=".*?"/g, '');
        code = code.replace(/<title>.*<\/title>/g, '');
        return code;
      }}
    />
  );
};
